/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/comment': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18.29 7.09H6.11a1.06 1.06 0 000 2.12h12.17c.58 0 1.06-.47 1.06-1.06 0-.59-.47-1.06-1.05-1.06zM15.58 11.14H6.11a1.06 1.06 0 000 2.12h9.47a1.06 1.06 0 000-2.12z" _fill="currentColor"/><path pid="1" d="M20.99 1H3.41C2.08 1 1 2.08 1 3.41v13.52c0 1.33 1.08 2.41 2.41 2.41h1.65v3a1.043 1.043 0 001.05 1.05c.23 0 .45-.08.63-.21l5.13-3.85h9.11c1.33 0 2.41-1.08 2.41-2.41V3.41A2.396 2.396 0 0020.99 1zm-10.1 16.44l-3.72 2.79v-1.94c0-.58-.47-1.06-1.06-1.06h-2.7a.3.3 0 01-.3-.3V3.41c0-.16.13-.3.3-.3h17.58c.16 0 .29.13.29.3v13.52c0 .16-.13.3-.29.3h-9.47c-.22 0-.45.07-.63.21z" _fill="currentColor"/>'
  }
})
